import { render, staticRenderFns } from "./FacturaShow.vue?vue&type=template&id=f904fe0a"
import script from "./FacturaShow.vue?vue&type=script&lang=js"
export * from "./FacturaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports